<div class="spacer-large"></div>
<h2 class="mb28">Meldingen</h2>

<div *ngIf="tasks.length !== 0">
  <div>
    <ng-container *ngFor="let task of tasks.slice(0, limit)">
      <app-task [clientId]="clientId" [task]="task"></app-task>
    </ng-container>
    <ng-container *ngFor="let task of tasks.slice(limit, tasks.length)">
      <div *ngIf="!closed" @items>
        <app-task [clientId]="clientId" [task]="task"></app-task>
      </div>
    </ng-container>
  </div>
  <button (click)="closed = false"
          *ngIf="closed && tasks.length > limit"
          class="btn arrow-down auto block">
    lees meer meldingen
  </button>
</div>

<div *ngIf="tasks.length === 0" class="mt28">
  de Rekening en Verantwoording {{currentYear}} wordt in januari {{nextYear}} opengezet om ingevuld te worden. U kunt nu al beginnen met
  het inlezen en categoriseren van banktransacties ter voorbereiding.
</div>

